export const ordernacaoItem = (_itens: any[]): any[] => {
  return _itens.map((item, idx) => ({ ...item, num_sequencia: idx + 1 }));
};
